import { Box, Divider, type SxProps, TextField } from '@mui/material'
import React from 'react'

interface SelectPropertyPopoverSearchParams {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onSubmit?: () => void
  placeholder?: string
  rootSx?: SxProps
}

export function SelectPropertyPopoverSearch({
  value,
  onChange,
  onSubmit,
  placeholder = 'Search',
  rootSx,
}: SelectPropertyPopoverSearchParams) {
  return (
    <>
      <Box
        sx={{
          bgcolor: (theme) => (theme.palette.mode == 'light' ? 'grey.100' : 'transparent'),
          p: 1,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          ...(rootSx ?? {}),
        }}
      >
        <TextField
          autoFocus
          fullWidth
          size="small"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              onSubmit?.()
            }
          }}
          slotProps={{
            htmlInput: {
              sx: {
                paddingLeft: '8px',
              },
            },
          }}
        />
      </Box>
      <Divider />
    </>
  )
}
